import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'properEnumPipe'
})
export class ProperEnumPipe implements PipeTransform {

	transform(data:Object, valuesAre:"strings"|"numbers" = "numbers") : {key:any, value:any}[] {
		let a : any[] = [];
		Object.entries(data).forEach(([key, value], index) => {
			if (valuesAre == "strings" || !isNaN(parseInt(value))) {
				a.push({
					key: key,
					value: value
				})
			}
		});
		return a;
	}

}